// extracted by mini-css-extract-plugin
module.exports = {"screenOverlay":"menu_screenOverlay__2eYAk","modalWrapper":"menu_modalWrapper__2rdaW","menuContainer":"menu_menuContainer__3sYfx"};